<template>
  <div class="bg-white">
    <div class="overflow-hidden bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-max lg:max-w-7xl">
        <div class="relative mb-8 md:mb-2 md:px-6">
          <div class="max-w-prose text-base lg:max-w-none">
            <h2 class="font-semibold leading-6 text-teal-600">
              Über St. Audio
            </h2>
            <p class="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
              Mach deinen Podcast groß
            </p>
          </div>
        </div>
        <div class="relative">
          <div class="relative md:bg-white md:p-6">
            <div class="prose prose-lg prose-teal mt-6 text-gray-500 lg:mt-0">
              <p>
                St. Audio hilft wachstumsbereiten Podcaster*innen mit Ressourcen, Guidance, Training und Umsetzung beim Erreichen neuer Hörer*innen und beim Aufbau ihres Creator-Business’.
              </p>
              <p>
                Hier im &#127899; Studio haben wir einen Ort für dich geschaffen, in dem du erstmals alle Aspekte rund um dein Wachstum an einem Ort findest – von Reichweitentipps über Anleitungen und Best-Practice-Beispiele bis hin zur Wirksamkeits-Analyse.
              </p>
              <p>
                Unser selbstlernendes System analysiert fortlaufend, mit welchem Methoden-Mix vergleichbare Podcasts erfolgreich waren – und gibt die entsprechenden Empfehlungen weiter. Damit kannst du richtigen Marketing-Maßnahmen zur richtigen Zeit priorisieren.
              </p>
              <p>
                Diese Insights sind weltweit einmalig.<br/>&nbsp;
              </p>
            </div>
          </div>
        </div>
        <div class="relative z-10 mb-8 md:mb-2 md:px-6">
          <div class="max-w-prose text-base lg:max-w-none">
            <p class="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
              Willkommen im Club
            </p>
          </div>
        </div>
        <div class="relative">
          <div class="relative md:bg-white md:p-6">
            <div class="prose prose-lg prose-teal mt-6 text-gray-500 lg:mt-0">
              <p>
                Wenn du deine nächsten Meilensteine mit noch mehr Struktur angehen möchtest, dann komm doch in den &#127957; <a href="https://sanktaudio.de/growth-club/" target="_blank">Growth Club</a>. Darin begleiten wir Teams über drei Monate mit Wissen, Guidance und Feedback.
              </p>
              <p>
                Es hat sich gezeigt, dass insbesondere die initiale Strategie-Beratung, die strukturierte Roadmap und der fortlaufende Austausch mit uns und den anderen Podcaster*innen noch viel bessere Ergebnisse hervorbringen.
              </p>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 rounded-lg">
          <div class="mx-auto max-w-7xl py-12 px-4 sm:px-6 lg:flex lg:items-center lg:justify-between lg:py-16 lg:px-8">
            <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              <span class="block">
                Erfahre als Erstes, wie es weitergeht!
              </span>
              <span class="block text-teal-600">
                Wahlweise im Postfach oder Social-Feed.
              </span>
            </h2>
            <div class="mt-8 flex lg:mt-0 lg:flex-shrink-0">
              <div class="inline-flex rounded-md shadow">
                <a href="/newsletter" target="_blank" class="inline-flex items-center justify-center rounded-md border border-transparent bg-teal-600 px-5 py-3 text-base font-medium text-white hover:bg-teal-700">
                  Newsletter
                </a>
              </div>
              <div class="ml-3 inline-flex rounded-md shadow">
                <a href="/linkedin" target="_blank" class="inline-flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-teal-600 hover:bg-teal-50">
                  LinkedIn
                </a>
              </div>
              <div class="ml-3 inline-flex rounded-md shadow">
                <a href="/instagram" target="_blank" class="inline-flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-teal-600 hover:bg-teal-50">
                  Instagram
                </a>
              </div>
              <div class="ml-3 inline-flex rounded-md shadow">
                <a href="/twitter" target="_blank" class="inline-flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-teal-600 hover:bg-teal-50">
                  X
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>